import { useQuery } from "@tanstack/react-query";
import Api from "../Network";
import { usePermissions } from "./usePermissions";
import { PERMISSIONS } from "../Utilis/permissions";

export type SoundKey =
  | "new_order"
  | "new_activity"
  | "new_inquiry"
  | "new_complaint"
  | "activity_reply"
  | "status_changed";

export type SoundsMap = Record<
  SoundKey,
  { label: string; sound_url: string | null }
>;

export function useNotificationSounds() {
  const { hasPermission } = usePermissions();
  const canView = hasPermission(PERMISSIONS.NOTIFICATION_SOUNDS.VIEW);

  return useQuery<SoundsMap>({
    queryKey: ["notification-sounds"],
    queryFn: async () => {
      const res: any = await Api.get("company/notification-sounds");
      return res?.data ?? res;
    },
    enabled: canView,
    staleTime: 5 * 60_000,
  });
}
